import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Support} from "../../../shared/interface/support";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {CorporationService} from "../../../shared/services/corporation.service";

@Component({
  selector: 'app-corporation-details',
  templateUrl: './corporation-details.component.html',
  styleUrls: ['./corporation-details.component.scss']
})
export class CorporationDetailsComponent implements  OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  supportId: string;
  supportObject?: Support;
  support: ReplaySubject<Support> = new ReplaySubject<Support>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  constructor( private route: ActivatedRoute,
               private corporationService: CorporationService,
               private snack: MatSnackBar,
               private dialog: MatDialog,
               private auth: AuthService,
  )
  {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.supportId = params.id;
        this.loadSupport();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadSupport(): void {
    this.corporationService.get(this.supportId).subscribe((support: Support) => {
      this.support.next(support);
      this.supportObject = support;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
